import states from "../assets/data/states.json";
import filingStatus from "../assets/data/filing-status.json";
import payPeriodType from "../assets/data/pay-period-type.json";
import paymentMethod from "../assets/data/payment-method.json";
import employment from "../assets/data/employment-type.json";

export const STATESLIST = states.states;
export const FILINGSTATUS = filingStatus.status;
export const PAYPERIODTYPE = payPeriodType.payType;
export const PAYMENTMETHOD = paymentMethod.paymentMethod;
export const EMPLOYMENTTYPE = employment.employmentType;
